// dev-portal/src/utils/dentuluProSSO.js

export const initializeDentuluProButton = (buttonId, flow = 'login') => {
    const button = document.getElementById(buttonId);

    if (!button) {
        console.error('Dentulu Pro button not found');
        return;
    }

    // Set up the callback handler for when user completes login in the popup
    window.onDentuluLogin = function (data, redirectUri) {
        // Use backend API base URL from environment variable
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const callbackUrl = `${apiBaseUrl}/api/sso/dentulu-callback`;

        const formData = new URLSearchParams();
        formData.append('token', data.token);
        formData.append('type', data.type);
        formData.append('user_email', data.user_email);
        formData.append('user_level', data.user_level);
        formData.append('stripe_customer_id', data.stripe_customer_id);

        // Store flow in localStorage for reference
        localStorage.setItem('dentulu_sso_flow', flow);

        fetch(callbackUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: formData
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error("Callback POST failed");
                }
                return response.json();
            })
            .then(result => {
                if (result.status && result.access_token) {
                    // Store token and user info
                    localStorage.setItem('token', result.access_token);
                    localStorage.setItem('role', result.user.role);

                    // Clear SSO flow
                    localStorage.removeItem('dentulu_sso_flow');

                    // Redirect to dashboard or specified route
                    const redirectTo = result.post_login_route || '/dashboard';
                    window.location.href = redirectTo;
                } else {
                    alert("Login failed: " + (result.message || 'Unknown error'));
                }
            })
            .catch(error => {
                console.error("Error sending login data to server:", error);
                alert("Authentication failed. Please try again.");
                window.location.href = '/login';
            });
    };

    // Click handler for the button - uses backend-driven auth
    const handleClick = async (e) => {
        e.preventDefault();
        
        try {
            // Get the API base URL
            const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
            
            // Build the redirect URI for the callback
            const redirectUri = `${apiBaseUrl}/api/sso/dentulu-callback`;
            
            // Call backend to initialize auth and get the auth URL
            const response = await fetch(`${apiBaseUrl}/api/sso/init-auth`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ redirect_uri: redirectUri })
            });
            
            if (!response.ok) {
                throw new Error("Failed to initialize authentication");
            }
            
            const result = await response.json();
            
            if (!result.success || !result.auth_url) {
                throw new Error(result.error || "Failed to get authentication URL");
            }
            
            // Open the auth window using the SDK
            if (typeof window.DentuluSDK !== 'undefined' && window.DentuluSDK.openAuthWindow) {
                window.DentuluSDK.openAuthWindow(result.auth_url, "Dentulu Pro Login");
            } else {
                // Fallback: open window directly
                const w = 500, h = 600;
                const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
                const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
                const width = window.innerWidth || document.documentElement.clientWidth || screen.width;
                const height = window.innerHeight || document.documentElement.clientHeight || screen.height;
                const left = ((width / 2) - (w / 2)) + dualScreenLeft;
                const top = ((height / 2) - (h / 2)) + dualScreenTop;
                
                window.open(result.auth_url, "Dentulu Pro Login", 
                    `scrollbars=yes, width=${w}, height=${h}, top=${top}, left=${left}`);
            }
        } catch (error) {
            console.error("Error initializing Dentulu Pro SSO:", error);
            alert("Dentulu Pro sign-in is not available at this time. Please use email and password to login.");
        }
    };
    
    // Attach click handler
    button.addEventListener('click', handleClick);
    button._dentuluClickHandler = handleClick;

    console.log('Dentulu Pro button initialized for:', buttonId);

    // Return cleanup function
    return () => {
        const btn = document.getElementById(buttonId);
        if (btn && btn._dentuluClickHandler) {
            btn.removeEventListener('click', btn._dentuluClickHandler);
            delete btn._dentuluClickHandler;
        }
        if (window.onDentuluLogin) {
            delete window.onDentuluLogin;
        }
    };
};